import React from "react";
// import firebase from "firebase/app";
import { Grid } from "semantic-ui-react";
import FormAccordion from "./Tool/FormAccordion";

// import pdfFileObject from "../result.json";
const DevTools = () => {
  return (
    <Grid stackable columns={2}>
      <Grid.Row columns={3}>
        <Grid.Column columns={5}>
          <FormAccordion position="left" />
        </Grid.Column>
        <Grid.Column columns={6}>
          <FormAccordion position="center" />
        </Grid.Column>
        <Grid.Column columns={5}>
          <FormAccordion position="right" />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default DevTools;
